// Shared pill classes for the Advisors tab and the advisor students page.
export const PILL = 'inline-block rounded-full px-2 py-0.5 text-xs';
export const WARN_PILL = `${PILL} bg-state-warning-bg text-state-warning-text`;
// Bordered, not filled, so it stays visible on a hovered (sunken) row.
export const PLAIN_PILL = `${PILL} border border-line`;
